import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { ErrorPrefix } from "Constants/constants";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { HealthProductDetailsFormValues } from "./healthProductDetailsInterfaces";

export const validationSchema =
  (): Yup.ObjectSchema<HealthProductDetailsFormValues> => {
    const { getText } = TextManager;

    return Yup.object()
      .defined()
      .shape({
        isFitForWork: Yup.mixed<BooleanFormType>()
          .required(getText("healthform.validation.isfitforwork_required"))
          .oneOf(
            [BooleanFormType.TRUE],
            ErrorPrefix.BREAKING +
              getText("healthform.alerttitle.isfitforwork"),
          ),
        isOnSickLeave: Yup.mixed<BooleanFormType>()
          .required(getText("healthform.validation.isonsickleave_required"))
          .oneOf(
            [BooleanFormType.FALSE],
            ErrorPrefix.BREAKING +
              getText("healthform.alerttitle.isonsickleave"),
          ),
        inTreatment: Yup.mixed<BooleanFormType>()
          .required(getText("healthform.validation.intreatment_required"))
          .oneOf(
            [BooleanFormType.FALSE],
            ErrorPrefix.BREAKING + getText("healthform.alerttitle.intreatment"),
          ),
        isPlannedAnyKindOfTreatment: Yup.mixed<BooleanFormType>()
          .required(
            getText(
              "healthform.validation.isplannedanykindoftreatment_required",
            ),
          )
          .oneOf(
            [BooleanFormType.FALSE],
            ErrorPrefix.BREAKING +
              getText("healthform.alerttitle.isplannedanykindoftreatment"),
          ),
        isSmoker: Yup.mixed<BooleanFormType>().required(
          getText("healthform.validation.issmoker_required"),
        ),
      });
  };
